var vimanaTheme = require("../vimana");
module.exports = /*:: (*/Object.assign({}, vimanaTheme, {
  brandName: "Dmgmori",
  bodyClassName: "dmgmori-theme",
  documentationURL: "url(https://dmgmori.sharepoint.com/sites/CO_Connectivity_Public/SitePages/Remote-Alarm-Analysis.aspx)"
}) /*:: :Object)*/;